/**
 * Plain-language display only. Action keys and actual review/approval routes
 * continue to come from the authenticated backend. No approval state inferred.
 */
const REVIEW_LABELS = {
  recover_application: 'Check application',
  review_possible_historical_application: 'Check saved application',
  complete_application: 'Applicant to complete application',
  confirm_recovered_application: 'Applicant to confirm application',
  add_work_history: 'Applicant to add work history',
  rebuild_work_history: 'Check work history',
  explain_or_revise_employment_gaps: 'Applicant to explain work gaps',
  review_employment_gaps: 'Check work gaps',
  recover_cv: 'Check CV',
  review_cv: 'Check CV',
  request_cv_replacement: 'Ask for a new CV',
  request_cv_upload: 'Ask for a CV',
  wait_for_cv_replacement: 'Waiting for a new CV',
  review_declarations: 'Check declarations',
  complete_declarations: 'Applicant to complete declarations',
};

/** Unknown actions are still accessible via the existing detailed evidence. */
export function plainEmploymentReviewAction(key, fallback) {
  if (REVIEW_LABELS[key]) return REVIEW_LABELS[key];
  const label = String(fallback || '').trim();
  if (!label || /[_/]{1,}|^\w+(?:_\w+)+$/i.test(label)) return 'Open details';
  return label.replace(/\bEmployment Review\b/gi, 'work history review')
    .replace(/\bCV\/Resume\b/gi, 'CV')
    .replace(/\bOsabea reviews\b/gi, 'Check')
    .replace(/\bCompliance Review\b/gi, 'final checks');
}

export function plainRecruitmentNextStep({ nextAction, approval }) {
  if (approval?.statusUnavailable) {
    return { owner: 'Team', label: 'Check status again' };
  }
  const original = nextAction || {};
  const owner = original.owner === 'Applicant' ? 'Applicant'
    : original.owner === 'System' ? 'System' : 'Team';
  return {
    owner,
    label: plainEmploymentReviewAction(
      original.action,
      original.label || 'Open applicant record',
    ),
  };
}
